import { PREFIX } from "./helper";
import { initialState } from "./initial-state";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { postUserTrackerValue } from "./thunks";
import { RootState } from "redux/store";
import { IDeeplinkState, ShopSectionTitles } from "./types";

export const commonSlice = createSlice({
	name: PREFIX,
	initialState,
	reducers: {
		onCollapseSingleItemCategory: (state, action: PayloadAction<boolean>) => {
			state.collapseTutorialCategory = action.payload;
		},
		onDisplayLimitedDealsDot: (state, action: PayloadAction<boolean>) => {
			state.displayLimitedDealsDot = action.payload;
		},
		onScrollToShopSection: (
			state,
			action: PayloadAction<ShopSectionTitles | undefined>
		): void => {
			state.scrollToSection = action.payload;
		},
		onSetDeeplinkState: (state, action: PayloadAction<IDeeplinkState>) => {
			state.deeplinkState = action.payload;
		},
		onIsLPAnimationPlaying: (state, action: PayloadAction<boolean>) => {
			state.isLPAnimationPlaying = action.payload;
		},
		onSetTutorialSlideNumber: (state, action: PayloadAction<number>) => {
			state.tutorialSlideNumber = action.payload;
		},
		onSeeFullTutorialAgain: (state, action: PayloadAction<boolean>): void => {
			state.seeFullTutorialAgain = action.payload;
		}
	},
	extraReducers: (builder) => {
		builder.addCase(postUserTrackerValue.fulfilled, () => {});
	}
});

export const {
	onCollapseSingleItemCategory,
	onDisplayLimitedDealsDot,
	onSetTutorialSlideNumber,
	onIsLPAnimationPlaying,
	onSeeFullTutorialAgain,
	onScrollToShopSection,
	onSetDeeplinkState
} = commonSlice.actions;

export const selectCommonState = (state: RootState) => state.common;
export default commonSlice.reducer;
export * from "./types";
export * from "./thunks";
